import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { BusinessDeclarationUsPerson } from '../model';
import { IFormStore } from '../interface';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: BusinessDeclarationUsPerson };

const initialState: State = { state: 'idle' };

@Injectable()
export class BusinessDeclarationUsPersonStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<BusinessDeclarationUsPerson>((_, data) => ({
    state: 'valid',
    data: BusinessDeclarationUsPerson.fromJson(data),
  }));
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));

  constructor() {
    super(initialState);
  }
}
